var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4321 0.18457H2.56792C1.15193 0.18457 0 1.33654 0 2.75249V11.4347C0 12.8507 1.15193 14.0026 2.56792 14.0026H3.5756L3.59532 16.2696C3.59708 16.4785 3.71707 16.6684 3.90502 16.7598C3.98141 16.7969 4.06364 16.8151 4.14548 16.8151C4.26498 16.8151 4.3836 16.7762 4.48175 16.7005L7.97716 14.0026H15.4321C16.8481 14.0026 18 12.8507 18 11.4347V2.75249C18 1.33654 16.8481 0.18457 15.4321 0.18457ZM16.8995 11.4347C16.8995 12.2439 16.2412 12.9021 15.4321 12.9021H7.78954C7.66789 12.9021 7.54966 12.9425 7.45334 13.0168L4.68615 15.1525L4.67132 13.4476C4.66871 13.1456 4.42311 12.9021 4.12109 12.9021H2.56792C1.7588 12.9021 1.10053 12.2439 1.10053 11.4347V2.75249C1.10053 1.94337 1.7588 1.2851 2.56792 1.2851H15.4321C16.2412 1.2851 16.8995 1.94337 16.8995 2.75249L16.8995 11.4347Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMessage);
export default __webpack_public_path__ + "static/media/light_message.da94fe1e3b1620650256dda1bcfb24a3.svg";
export { ForwardRef as ReactComponent };